import { Code, Description } from "@mui/icons-material";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image,
} from "@react-pdf/renderer";

// Styles
const styles = StyleSheet.create({
    page: {
        padding: 20,
        fontSize: 10,
    },
    section: {
        marginBottom: 10,
        marginTop: 80,
    },
    headerContainer: {
        alignItems: "center",
        justifyContent: "flex-start",
        marginTop: 20,
        marginBottom: 20
    },
    headerText: {
        fontSize: 16,
        fontWeight: "bold",
        textAlign: "center",
        marginBottom: 15,
        marginTop: 80,
    },
    // subHeaderText: {
    //     fontSize: 10,
    //     fontWeight: "bold",
    //     //textAlign: "center",
    //     marginBottom: 5
    // },
    row: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 5
    },
    subHeaderText: {
        fontSize: 10,
        fontWeight: "bold",
        width: "48%" // Allows two items side by side with spacing
    },
     subText: {
        fontSize: 10,
        fontWeight: "bold",
        width: "48%", // Allows two items side by side with spacing
        marginBottom:5    },

    table: {
        display: "table",
        width: "100%",
        borderWidth: 1,
        borderColor: "#000",
        borderStyle: "solid",
        marginTop: 10
    },
    tableRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: "#000",
        borderBottomStyle: "solid",
    },
    tableRowLast: {
        flexDirection: "row",
    },
    //S.No,Effort Header
    tableColHeader1: {
        width: "5%",
        borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        fontWeight: "bold",
        backgroundColor: "#EEE",
        textAlign: "center",
    },
    tableCol1: {
        width: "5%",
        borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        textAlign: "right",
    },
    //Date Header
    tableColHeader: {
        width: "8%",
        borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        fontWeight: "bold",
        backgroundColor: "#EEE",
        textAlign: "center",
    },
    tableCol: {
        width: "8%",
        borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        textAlign: "left",
    },
    //Status
    tableColHeaderStatus: {
        width: "10%",
        // borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        fontWeight: "bold",
        backgroundColor: "#EEE",
        textAlign: "center",
    },
    tableColStatus: {
        width: "10%",
        // borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        textAlign: "left",
    },
    //Echeduled to Header
    tableColHeaderSmall: {
        width: "15%",
        borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        fontWeight: "bold",
        backgroundColor: "#EEE",
        textAlign: "center",
    },
    tableColSmall: {
        width: "15%",
        borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        textAlign: "left",
    },
    //Task header
    tableColHeaderTask: {
        width: "20%",
        borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        fontWeight: "bold",
        backgroundColor: "#EEE",
        textAlign: "center",
    },
    tableColTask: {
        width: "20%",
        borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        textAlign: "left",
    },
    //Comments Header
    tableColHeaderDescription: {
        //flex: 1,
        width: "22%",
        borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        fontWeight: "bold",
        backgroundColor: "#EEE",
        textAlign: "center",
    },
    tableColDescription: {
        width: "22%",
        borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        textAlign: "left",
    },


 headerWrapper: {
    position: "absolute",
    top: 15,
    left: 20,
    right: 20,
    height: 50,
    justifyContent: "center",
    alignItems: "center",
  },
  headerImage: {
    width: "100%",
    height: 50,
    objectFit: "contain",
  },
 /* FOOTER */
  footerWrapper: {
    position: "absolute",
    bottom: 25,
    left: 5,
    right: 5,
    height: 80,
    justifyContent: "center",
    alignItems: "center",
  },
  footerImage: {
    width: "100%",
    height: 100,
    objectFit: "cover",
  },

});

// Split data: 20 on first page, 26 afterwards
// const paginateData = (data) => {
//     const firstPage = data.slice(0, 20);
//     const otherPages = [];

//     for (let i = 20; i < data.length; i += 26) {
//         otherPages.push(data.slice(i, i + 26));
//     }

//     return [firstPage, ...otherPages];
// };


// ===== CONFIG =====
const FIRST_PAGE_COUNT = 8;
const OTHER_PAGE_COUNT = 10;

const paginateData = (data) => {
  const firstPage = data.slice(0, FIRST_PAGE_COUNT);
  const otherPages = [];

  for (
    let i = FIRST_PAGE_COUNT;
    i < data.length;
    i += OTHER_PAGE_COUNT
  ) {
    otherPages.push(data.slice(i, i + OTHER_PAGE_COUNT));
  }

  return [firstPage, ...otherPages];
};

//const TimeSheetPDF = ({ data = [], filters = {} }) => {
const SprintPDF = ({ data = [], filters = {}, projectName = "", managerName = "" }) => {
    const pages = paginateData(data);
    pages.forEach((page, i) => {
        console.log(`Page ${i + 1} first row index:`, data.indexOf(page[0]));
    });
    const formatDate = (inputDate) => {
        if (!inputDate) return "";
        const [year, month, day] = inputDate.split("-");
        return `${day}-${month}-${year}`;
    };

    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    return (
        <Document>

            {pages.map((pageData, pageIndex) => (
                <Page size="A4" orientation="landscape" style={styles.page} key={pageIndex}>
   <View fixed style={styles.headerWrapper}>
            {filters.HeaderImg && (
              <Image
                src={`${filters.Imageurl}/uploads/images/${filters.HeaderImg}`}
                style={styles.headerImage}
              />
            )}
          </View>
                    {pageIndex === 0 && (

                        <View style={styles.headerTextContainer}>
                            <Text style={styles.headerText}>
                                {`Sprint`}
                            </Text>
                            <Text style={styles.subText}>
                                {"Comp -> Completed ||PP -> Project Plan"}
                            </Text>

                            <View style={styles.row}>
                                <Text style={styles.subHeaderText}>{`Code          : ${filters.Code}`}</Text>
                                <Text style={styles.subHeaderText}>{`Description: ${filters.Description}`}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.subHeaderText}>{`From Date  : ${filters.FromDate}`}</Text>
                                <Text style={styles.subHeaderText}>{`To Date       : ${filters.ToDate}`}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.subHeaderText}>{`Milestone   : ${filters.Milestone}`}</Text>
                                <Text style={styles.subHeaderText}>{`Stages        : ${filters.Stages}`}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.subHeaderText}>{`Activities    : ${filters.Activities}`}</Text>
                            </View>


                            {/* <Text style={styles.subHeaderText}>
                {"Comp -> Completed ||Appr -> Approved"}
              </Text> */}
                        </View>

                    )}

                    <View 
                    // style={styles.table}
                     style={[
    styles.table,
    pageIndex !== 0 && { marginTop: 70 }  // adjust 60–90 if needed
  ]}
                    >
                        <View style={styles.tableRow}>
                            <Text style={styles.tableColHeader1}>SL#</Text>
                            <Text style={styles.tableColHeaderSmall}>Scheduled To</Text>
                            <Text style={styles.tableColHeaderTask}>Task</Text>
                            <Text style={styles.tableColHeader}>PP Date</Text>
                            <Text style={styles.tableColHeader1}>Effort</Text>
                            <Text style={styles.tableColHeader}>Scheduled Date</Text>
                            {/* <Text style={styles.tableColHeaderSmall}></Text> */}
                            <Text style={styles.tableColHeader}>Comp Date</Text>
                            <Text style={styles.tableColHeaderDescription}>Comments</Text>
                            <Text style={styles.tableColHeaderStatus}>Status</Text>
                        </View>

                        {pageData.map((row, rowIndex) => {
                            const globalIndex =
                pageIndex === 0
                  ? rowIndex + 1
                  : FIRST_PAGE_COUNT +
                    (pageIndex - 1) * OTHER_PAGE_COUNT +
                    rowIndex +
                    1;
                            const isLast = rowIndex === pageData.length - 1;
                            return (
                                <View
                                    key={rowIndex}
                                    style={isLast ? styles.tableRowLast : styles.tableRow}
                                >
                                    <Text style={styles.tableCol1}>
                                     {globalIndex}
                                        {/*{rowIndex + 1}*/}
                                    </Text>
                                    <Text style={styles.tableColSmall}>
                                        {row.EmployeeName}
                                    </Text>
                                    <Text style={styles.tableColTask}>
                                        {row.Task}
                                    </Text>
                                    <Text style={styles.tableCol}>
                                        {row.ProjectPlanDate}
                                    </Text>
                                    <Text style={styles.tableCol1}>
                                        {row.Effort}
                                    </Text>
                                    <Text style={styles.tableCol}>
                                        {row.ScheduledDate}
                                    </Text>
                                    <Text style={styles.tableCol}>
                                        {row.CompletedDate?.split(" ")[0]}
                                    </Text>
                                    <Text style={styles.tableColDescription}>
                                        {row.Comments}
                                    </Text>
                                    <Text style={styles.tableColStatus}>
                                        {row.Status}
                                    </Text>
                                </View>
                            );
                        })}
                    </View>
                    <View
                        fixed
                        style={{
                            position: "absolute",
                            bottom: 10,
                            left: 0,
                            right: 0,
                            textAlign: "center",
                            fontSize: 10,
                        }}
                    >
                        <Text>Page {pageIndex + 1} of {pages.length}</Text>
                    </View>
                     <View fixed style={styles.footerWrapper}>
                                {filters.FooterImg && (
                                  <Image
                                    src={`${filters.Imageurl}/uploads/images/${filters.FooterImg}`}
                                    style={styles.footerImage}
                                  />
                                )}
                              </View>
                </Page>
            ))}
        </Document>
    );
};

export default SprintPDF;
